import React, { useRef, useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { categoryApi } from "../services/api/categoryApi";
import { cartApi } from "../services/api/cartApi";
import { showSuccess } from "../lib/toast";
import { ICategory } from "../types";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import WishlistDrawer from "./WishlistDrawer";
import { useAuth } from "../contexts/AuthContext";
import ImageWithLoader from "./ImageWithLoader";

const Header: React.FC = () => {
  const mostSellingCarouselRef = useRef<any>(null);
  const [categories, setCategories] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [cartCount, setCartCount] = useState(0);
  const [showSection, setShowSection] = useState(false);
  const navigate = useNavigate();
  const { isLoggedIn, isSignUp, logout } = useAuth();

  const scrollToTop = () => {
    setTimeout(() => window.scrollTo({ top: 0, behavior: 'auto' }), 0);
  };

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const response = await categoryApi.getCategories();
      const allSubCategories = response.data.flatMap(
        (category: ICategory) => category.subCategories.map(sub => sub),
      );
      setCategories(allSubCategories || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {

    function handleScroll() {
      // if(innerWidth <= 2047){
      setShowSection(false);
      // }
      // setInnerWidth(window.innerWidth);
    }

    function handleResize() {
      // if(innerWidth <= 2047){
      // setShowSection(false);
      // }
    }

    // const handleResize = () => console.log("resize", window.innerWidth);


    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener("resize", handleResize);
    }
  }, []);

  useEffect(() => {
    const fetchCartCount = async () => {
      if (!isLoggedIn) {
        setCartCount(0);
        return;
      }

      try {
        const response = await cartApi.getCart();
        setCartCount(response.data?.totalItems || 0);
      } catch (error) {
        console.error("Error fetching cart count:", error);
        setCartCount(0);
      }
    };

    fetchCartCount();
  }, [isLoggedIn]);

  // Listen for cart update events
  useEffect(() => {
    const handleCartUpdate = () => {
      const fetchCartCount = async () => {
        if (!isLoggedIn) {
          setCartCount(0);
          return;
        }

        try {
          const response = await cartApi.getCart();
          setCartCount(response.data?.totalItems || 0);
        } catch (error) {
          console.error("Error fetching cart count:", error);
          setCartCount(0);
        }
      };

      fetchCartCount();
    };

    window.addEventListener('cartUpdated', handleCartUpdate);

    return () => {
      window.removeEventListener('cartUpdated', handleCartUpdate);
    };
  }, [isLoggedIn]);

  const goToPreviousSlide = () => {
    if (mostSellingCarouselRef.current) {
      mostSellingCarouselRef.current.previous();
    }
  };

  const goToNextSlide = () => {
    if (mostSellingCarouselRef.current) {
      mostSellingCarouselRef.current.next();
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      showSuccess("Successfully logged out");
      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };


  return (
    <header>
      <div className="header_section">
        <div className="header_sec" id="header_sec">
          <div className="container">
            <div className="header_area">
              <div className="row align-items-center">
                <div className="col-lg-3 col-4">
                  <div className="header_logo">
                    <Link to="/" onClick={scrollToTop}>
                      <span>
                        <img
                          src="/assets/images/Digi_Cartt_logo.svg"
                          alt="Digi_Cartt_logo"
                        />
                      </span>
                      <span className="d-lg-inline-block d-none">
                        Digi Cartt
                      </span>
                    </Link>
                  </div>
                </div>
                <div className="col-lg-7 col-4">
                  <div className="navbar_content">
                    <nav className="p-0 navbar navbar-expand-lg">
                      <button
                        className="toggler-icon d-lg-none"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasLeft"
                        aria-controls="offcanvasLeft"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M4 5L16 5"
                            stroke="#112C3B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M4 12L20 12"
                            stroke="#112C3B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M4 19L12 19"
                            stroke="#112C3B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                      <div
                        className="offcanvas offcanvas-start"
                        tabIndex={-1}
                        id="offcanvasLeft"
                        aria-labelledby="offcanvasLeftLabel"
                      >
                        <div className="pb-0 offcanvas-header d-lg-none">
                          <p>Menu</p>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div className="offcanvas-body justify-content-lg-center">
                          <div className="navbar_info">
                            <ul className="navbar-nav">
                              <li className="nav-item">
                                <NavLink
                                  className={({ isActive }) =>
                                    `nav-link ${isActive ? "active fw-bold" : ""}`
                                  }
                                  to="/"
                                  onClick={scrollToTop}
                                >
                                  Home
                                </NavLink>
                              </li>
                              <li className="nav-item dropdown">
                                <button
                                  className="nav-link dropdown-toggle"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                  onClick={fetchCategories}
                                  onMouseEnter={() => {
                                    setShowSection(true);
                                    fetchCategories();
                                  }}
                                >
                                  Categories
                                </button>
                                <div className={`dropdown-menu ${showSection ? 'show' : ''}`}
                                     onMouseLeave={() => setShowSection(false)}>
                                  {showSection && <div className="nav_inner_list">
                                      <div className="container">
                                          <div className="row">
                                              <div className="col-12">
                                                  <div className="nav_inner_list_title_area">
                                                      <p className="heading_text_4 font_one color_darkblur">
                                                          Categories
                                                      </p>
                                                      <div className="title_arrow_box d-lg-flex d-none">
                                                          <button
                                                              onClick={goToPreviousSlide}
                                                              className="arrow-btn"
                                                              aria-label="Previous"
                                                          >
                                                              <img
                                                                  src="/assets/images/nav_arrow_left.png"
                                                                  alt="Previous"
                                                              />
                                                          </button>
                                                          <button
                                                              onClick={goToNextSlide}
                                                              className="arrow-btn"
                                                              aria-label="Next"
                                                          >
                                                              <img
                                                                  src="/assets/images/nav_arrow_right.png"
                                                                  alt="Next"
                                                              />
                                                          </button>
                                                      </div>
                                                  </div>
                                              </div>
                                              <div className="col-12">
                                                {loading ? (
                                                  <div className="d-flex flex-column align-items-center justify-content-center">
                                                    <div
                                                      className="spinner-border text-dark"
                                                      role="status"
                                                    >
                                                <span className="visually-hidden">
                                                  Loading...
                                                </span>
                                                    </div>
                                                    <p className="mt-3 font_two">
                                                      Loading...
                                                    </p>
                                                  </div>
                                                ) : categories.length > 0 ? (
                                                  <Carousel
                                                    ref={mostSellingCarouselRef}
                                                    additionalTransfrom={0}
                                                    arrows={false}
                                                    autoPlay={true}
                                                    autoPlaySpeed={4000}
                                                    infinite
                                                    responsive={{
                                                      desktop: {
                                                        breakpoint: {
                                                          max: 3000,
                                                          min: 1024,
                                                        },
                                                        items: 6,
                                                        slidesToSlide: 1,
                                                      },
                                                      tablet: {
                                                        breakpoint: {
                                                          max: 1024,
                                                          min: 464,
                                                        },
                                                        items: 2,
                                                        slidesToSlide: 1,
                                                      },
                                                      mobile: {
                                                        breakpoint: {
                                                          max: 464,
                                                          min: 0,
                                                        },
                                                        items: 1,
                                                        slidesToSlide: 1,
                                                      },
                                                    }}
                                                    showDots={false}
                                                    keyBoardControl
                                                    customTransition="transform 500ms ease-in-out"
                                                    transitionDuration={500}
                                                    containerClass="most_selling_art_carousel"
                                                    itemClass="most_selling_art_item"
                                                  >
                                                    {categories.map(
                                                      (category: any, index) => (
                                                        <>
                                                          <NavLink
                                                            key={index}
                                                            to={`/products?collection=Canvas&category=${encodeURIComponent(category.name)}`}
                                                            className="nav_inner_img_box"
                                                            onClick={scrollToTop}
                                                          >
                                                            <ImageWithLoader
                                                              src={
                                                                category.image
                                                              }
                                                              style={{ height: "180px", width: "100%", objectFit: "cover" }}
                                                              alt={category.name}
                                                              fallbackSrc="/assets/images/nav_img.png"
                                                            />
                                                            {category.name}
                                                          </NavLink>
                                                        </>
                                                      ),
                                                    )}
                                                  </Carousel>
                                                ) : (
                                                  <p>No Categories found</p>
                                                )}
                                              </div>
                                          </div>
                                      </div>
                                  </div>}
                                </div>
                              </li>
                              {/*<li className="nav-item dropdown">*/}
                              {/*  <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Collections</a>*/}
                              {/*  <div className="dropdown-menu">*/}
                              {/*    <div className="nav_inner_list">*/}
                              {/*      <div className="container">*/}
                              {/*        <div className="row">*/}
                              {/*          <div className="col-12">*/}
                              {/*            <div className="nav_inner_list_title_area">*/}
                              {/*              <p className="heading_text_4 font_one color_darkblur">Collections</p>*/}
                              {/*            </div>*/}
                              {/*          </div>*/}
                              {/*          <div className="col-12">*/}
                              {/*            <div className="nav_inner_list_area">*/}
                              {/*              {[1, 2, 3, 4, 5, 6].map((num) => (*/}
                              {/*                <div key={num} className="nav_inner_details_box">*/}
                              {/*                  <div className="nav_inner_details_box_img">*/}
                              {/*                    <img src="/assets/images/nav_img.png" alt="nav_img" />*/}
                              {/*                  </div>*/}
                              {/*                  <div className="nav_inner_details_box_info font_two color_darkblue">*/}
                              {/*                    <p className="nav_inner_details_box_heading fw_500">Golden Autumn - Textured Nature Abstract Painting</p>*/}
                              {/*                    <p className="nav_inner_details_info fw_500">Maulik Vasani, United States</p>*/}
                              {/*                    <div className="nav_inner_details_price_box">*/}
                              {/*                      <span className="nav_box_price fw_700">$1400.00</span>*/}
                              {/*                      <span className="nav_box_cm fw_500">104 X 104 cm</span>*/}
                              {/*                    </div>*/}
                              {/*                  </div>*/}
                              {/*                </div>*/}
                              {/*              ))}*/}
                              {/*            </div>*/}
                              {/*          </div>*/}
                              {/*          <div className="col-12">*/}
                              {/*            <div className="text-end inner_nav_btn_area">*/}
                              {/*              <a href="#" className="arrow_btn_one">*/}
                              {/*                <span className="btn_text">View All</span>*/}
                              {/*                <span className="btn_icon">*/}
                              {/*                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">*/}
                              {/*                    <path d="M17.9998 6H18.7498V5.25H17.9998V6ZM17.9998 6L17.4695 5.46967L5.46967 17.4697L6 18L6.53033 18.5303L18.5301 6.53033L17.9998 6ZM10.9999 6V6.75H17.9998V6V5.25H10.9999V6ZM17.9998 6H17.2498V12.9999H17.9998H18.7498V6H17.9998Z" fill="#E7D5AD"/>*/}
                              {/*                  </svg>*/}
                              {/*                </span>*/}
                              {/*              </a>*/}
                              {/*            </div>*/}
                              {/*          </div>*/}
                              {/*        </div>*/}
                              {/*      </div>*/}
                              {/*    </div>*/}
                              {/*  </div>*/}
                              {/*</li>*/}
                              <li className="nav-item">
                                <NavLink
                                  className={({ isActive }) =>
                                    `nav-link ${isActive ? "active fw-bold" : ""}`
                                  }
                                  to="/products?collection=Canvas"
                                  onClick={scrollToTop}
                                >
                                  Collections
                                </NavLink>
                              </li>
                              <li className="nav-item">
                                <NavLink
                                  className={({ isActive }) =>
                                    `nav-link ${isActive ? "active fw-bold" : ""}`
                                  }
                                  to="/about"
                                  onClick={scrollToTop}
                                >
                                  About Us
                                </NavLink>
                              </li>
                              <li className="nav-item">
                                <NavLink
                                  className={({ isActive }) =>
                                    `nav-link ${isActive ? "active fw-bold" : ""}`
                                  }
                                  to="/contact"
                                  onClick={scrollToTop}
                                >
                                  Contact Us
                                </NavLink>
                              </li>
                            </ul>
                          </div>
                          <div className="header_nav_contact_box font_two d-lg-none">
                            <div className="footer_nav_box d-flex flex-column align-items-start">
                              <h2 className="text_20 fw_700 lineheight_normal">
                                Contact Us
                              </h2>
                              <ul className="footer_nav_list d-flex flex-column align-items-start">
                                <li>
                                  <a
                                    href="mailto:digicartt123@gmail.com"
                                    className="text_18 lineheight_normal d-flex"
                                  >
                                    <span>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <path
                                          d="M2 6L8.91302 9.91697C11.4616 11.361 12.5384 11.361 15.087 9.91697L22 6"
                                          stroke="#112C3B"
                                          strokeWidth="1.5"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M2.01577 13.4756C2.08114 16.5412 2.11383 18.0739 3.24496 19.2094C4.37608 20.3448 5.95033 20.3843 9.09883 20.4634C11.0393 20.5122 12.9607 20.5122 14.9012 20.4634C18.0497 20.3843 19.6239 20.3448 20.7551 19.2094C21.8862 18.0739 21.9189 16.5412 21.9842 13.4756C22.0053 12.4899 22.0053 11.5101 21.9842 10.5244C21.9189 7.45886 21.8862 5.92609 20.7551 4.79066C19.6239 3.65523 18.0497 3.61568 14.9012 3.53657C12.9607 3.48781 11.0393 3.48781 9.09882 3.53656C5.95033 3.61566 4.37608 3.65521 3.24495 4.79065C2.11382 5.92608 2.08114 7.45885 2.01576 10.5244C1.99474 11.5101 1.99475 12.4899 2.01577 13.4756Z"
                                          stroke="#112C3B"
                                          strokeWidth="1.5"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </span>
                                    digicartt123@gmail.com
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href="tel:+114845915178"
                                    className="text_18 lineheight_normal d-flex"
                                  >
                                    <span>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <path
                                          d="M3.77762 11.9424C2.8296 10.2893 2.37185 8.93948 2.09584 7.57121C1.68762 5.54758 2.62181 3.57081 4.16938 2.30947C4.82345 1.77638 5.57323 1.95852 5.96 2.6524L6.83318 4.21891C7.52529 5.46057 7.87134 6.08139 7.8027 6.73959C7.73407 7.39779 7.26737 7.93386 6.33397 9.00601L3.77762 11.9424ZM3.77762 11.9424C5.69651 15.2883 8.70784 18.3013 12.0576 20.2224M12.0576 20.2224C13.7107 21.1704 15.0605 21.6282 16.4288 21.9042C18.4524 22.3124 20.4292 21.3782 21.6905 19.8306C22.2236 19.1766 22.0415 18.4268 21.3476 18.04L19.7811 17.1668C18.5394 16.4747 17.9186 16.1287 17.2604 16.1973C16.6022 16.2659 16.0661 16.7326 14.994 17.666L12.0576 20.2224Z"
                                          stroke="#112C3B"
                                          strokeWidth="1.5"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </span>
                                    +1 14845915178
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <ul className="row footer_social_area">
                              {                              [
                                {
                                  name: "Instagram",
                                  icon: "M16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4ZM16 22C12.6863 22 10 19.3137 10 16C10 12.6863 12.6863 10 16 10C19.3137 10 22 12.6863 22 16C22 19.3137 19.3137 22 16 22ZM22.5 8.5C22.5 9.32843 21.8284 10 21 10C20.1716 10 19.5 9.32843 19.5 8.5C19.5 7.67157 20.1716 7 21 7C21.8284 7 22.5 7.67157 22.5 8.5Z",
                                },
                                {
                                  name: "Facebook",
                                  icon: "M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z",
                                },
                                {
                                  name: "YouTube",
                                  icon: "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z",
                                },
                                {
                                  name: "Twitter",
                                  icon: "M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z",
                                },
                              ].map((social, index) => (
                                <li key={index} className="col">
                                  <a href={social.name === "Instagram" ? "https://www.instagram.com" : social.name === "Facebook" ? "https://www.facebook.com" : social.name === "YouTube" ? "https://www.youtube.com" : "/"} target="_blank" rel="noopener noreferrer" aria-label={social.name}>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="32"
                                      height="32"
                                      viewBox="0 0 32 32"
                                      fill="none"
                                    >
                                      <path
                                        d={social.icon}
                                        stroke="#112C3B"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </nav>
                  </div>
                </div>
                <div className="col-lg-2 col-4">
                  <div className="cart_area d-flex justify-content-end">
                    <span className="header_lang d-sm-inline-block d-none">
                      USA ($)
                    </span>
                    <div className="header_user_box dropdown">
                      <button
                        className="header_user_btn dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M5.48131 12.9013C4.30234 13.6033 1.21114 15.0368 3.09388 16.8305C4.01359 17.7067 5.03791 18.3333 6.32572 18.3333H13.6743C14.9621 18.3333 15.9864 17.7067 16.9061 16.8305C18.7889 15.0368 15.6977 13.6033 14.5187 12.9013C11.754 11.2551 8.24599 11.2551 5.48131 12.9013Z"
                            stroke="#141B34"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M13.75 5.41667C13.75 7.48773 12.0711 9.16667 10 9.16667C7.92893 9.16667 6.25 7.48773 6.25 5.41667C6.25 3.3456 7.92893 1.66667 10 1.66667C12.0711 1.66667 13.75 3.3456 13.75 5.41667Z"
                            stroke="#141B34"
                            strokeWidth="1.5"
                          />
                        </svg>
                      </button>
                      <div className="dropdown-menu">
                        <ul
                          className="header_user_option_list"
                          style={{
                            listStyle: "none",
                            padding: 0,
                            margin: 0,
                          }}
                        >
                          {/* Show different content based on auth state */}
                          {isLoggedIn ? (
                            // Logged in user
                            <>
                              <li>
                                <Link
                                  to="/editprofile"
                                  className="dropdown-item"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "0.5rem 1rem",
                                    width: "100%",
                                    textAlign: "left",
                                    textDecoration: "none",
                                    color: "#112C3B",
                                  }}
                                >
                                  <span className="pr-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        d="M9.84 13.8844C6.8397 13.8844 4.39782 11.4425 4.39782 8.44218C4.39782 5.44188 6.8397 3 9.84 3C12.8403 3 15.2822 5.44188 15.2822 8.44218C15.2822 11.4425 12.8403 13.8844 9.84 13.8844ZM9.84 4.4197C7.62527 4.4197 5.81752 6.22745 5.81752 8.44218C5.81752 10.6569 7.62527 12.4647 9.84 12.4647C12.0547 12.4647 13.8625 10.6569 13.8625 8.44218C13.8625 6.22745 12.0547 4.4197 9.84 4.4197ZM17.9701 23.349C17.5821 23.349 17.2603 23.0272 17.2603 22.6392C17.2603 19.3739 13.9287 16.7238 9.84 16.7238C5.75126 16.7238 2.4197 19.3739 2.4197 22.6392C2.4197 23.0272 2.0979 23.349 1.70985 23.349C1.3218 23.349 1 23.0272 1 22.6392C1 18.5978 4.9657 15.3041 9.84 15.3041C14.7143 15.3041 18.68 18.5978 18.68 22.6392C18.68 23.0272 18.3582 23.349 17.9701 23.349Z"
                                        fill="#112C3B"
                                      />
                                    </svg>
                                  </span>
                                  Edit Profile
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="/previous-purchase"
                                >
                                  <span>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        d="M18.2916 12.1257L17.7003 5.69367C17.6875 5.55398 17.6229 5.42413 17.5193 5.32959C17.4157 5.23505 17.2805 5.18264 17.1402 5.18264H13.7054V3.87581C13.7054 1.84205 12.0508 0.1875 10.0171 0.1875C7.98335 0.1875 6.32875 1.84205 6.32875 3.87581V5.18259H2.89385C2.75357 5.18259 2.61835 5.235 2.51472 5.32954C2.41109 5.42408 2.34652 5.55394 2.33369 5.69362L1.11166 18.9892C1.06441 19.5037 1.22346 19.9773 1.5716 20.3589C1.91983 20.7406 2.37691 20.9423 2.89352 20.9423H11.9091C12.9456 22.6608 14.8305 23.8125 16.9795 23.8125C20.242 23.8125 22.8963 21.1582 22.8963 17.8957C22.8963 15.084 20.9248 12.7242 18.2916 12.1257ZM7.45375 3.87581C7.45375 2.46239 8.60364 1.3125 10.0171 1.3125C11.4305 1.3125 12.5804 2.46239 12.5804 3.87581V5.18259H7.45375V3.87581ZM2.89352 19.8173C2.6935 19.8173 2.53755 19.7485 2.40274 19.6007C2.26792 19.4529 2.21369 19.2913 2.23197 19.0921L3.40703 6.30764H6.32875V7.33322C6.32875 7.64386 6.58061 7.89572 6.89125 7.89572C7.20189 7.89572 7.45375 7.64386 7.45375 7.33322V6.30764H12.5804V7.33322C12.5804 7.64386 12.8323 7.89572 13.1429 7.89572C13.4536 7.89572 13.7054 7.64386 13.7054 7.33322V6.30764H16.6271L17.1486 11.9814C17.0923 11.9798 17.0359 11.9789 16.9795 11.9789C13.717 11.9789 11.0627 14.6332 11.0627 17.8957C11.0627 18.5681 11.1756 19.2145 11.3832 19.8173H2.89352ZM16.9795 22.6875C14.3372 22.6875 12.1876 20.5379 12.1876 17.8957C12.1876 15.2534 14.3372 13.1038 16.9795 13.1038C19.6217 13.1038 21.7713 15.2534 21.7713 17.8957C21.7713 20.5379 19.6217 22.6875 16.9795 22.6875ZM19.6229 16.1316C19.8377 16.356 19.83 16.7121 19.6056 16.9269L16.7333 19.677C16.6286 19.7774 16.4892 19.8333 16.3443 19.8332C16.2033 19.8333 16.0675 19.7804 15.9638 19.685L14.3619 18.2138C14.1331 18.0037 14.1179 17.6479 14.3281 17.4191C14.5382 17.1902 14.894 17.1751 15.1228 17.3852L16.3363 18.4996L18.8276 16.1143C19.0519 15.8995 19.408 15.9072 19.6229 16.1316Z"
                                        fill="#112C3B"
                                      />
                                    </svg>
                                  </span>
                                  Previous Purchase
                                </Link>
                              </li>
                              <li>
                                <button
                                  type="button"
                                  className="dropdown-item"
                                  data-bs-toggle="offcanvas"
                                  data-bs-target="#wishlistDrawer"
                                  aria-controls="wishlistDrawer"
                                  style={{ textDecoration: 'none', background: 'none', border: 'none', width: '100%', textAlign: 'left', padding: '0.5rem 1rem', display: 'flex', alignItems: 'center', gap: '8px' }}
                                >
                                  <span>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        d="M18.1721 4.67022C14.5795 2.74344 12 5.58373 12 5.58373C12 5.58373 9.42042 2.74344 5.8279 4.67021C1.47665 7.00391 1.1642 16.1428 12 20.2C22.8359 16.1428 22.5233 7.00392 18.1721 4.67022Z"
                                        stroke="#112C3B"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                      />
                                    </svg>
                                  </span>
                                  Favorite
                                </button>
                              </li>
                              <li>
                                <button
                                  onClick={handleLogout}
                                  className="dropdown-item"
                                  style={{
                                    color: "red",
                                    background: "none",
                                    border: "none",
                                    width: "100%",
                                    textAlign: "left",
                                    padding: "0.5rem 1rem",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <span className="pr-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M8.62844 6.28827C8.67519 6.35863 8.70763 6.43752 8.72388 6.52043C8.74014 6.60333 8.7399 6.68863 8.72317 6.77144C8.70645 6.85425 8.67358 6.93296 8.62643 7.00306C8.57928 7.07317 8.51877 7.13329 8.44838 7.18C7.18225 8.02016 6.22031 9.24569 5.70497 10.6752C5.18963 12.1046 5.14828 13.662 5.58705 15.1168C6.02582 16.5716 6.92138 17.8465 8.14115 18.7526C9.36091 19.6588 10.84 20.1481 12.3596 20.1481C13.8791 20.1481 15.3582 19.6588 16.578 18.7526C17.7978 17.8465 18.6933 16.5716 19.1321 15.1168C19.5709 13.662 19.5295 12.1046 19.0142 10.6752C18.4988 9.24569 17.5369 8.02016 16.2708 7.18C16.1286 7.08563 16.0298 6.93866 15.996 6.77143C15.9623 6.60419 15.9963 6.4304 16.0907 6.28827C16.1851 6.14614 16.332 6.04732 16.4993 6.01355C16.6665 5.97978 16.8403 6.01383 16.9824 6.10821C18.1323 6.87049 19.0754 7.9057 19.7276 9.12137C20.3798 10.337 20.7207 11.6953 20.72 13.0749C20.72 17.6922 16.9773 21.4349 12.36 21.4349C7.74271 21.4349 4 17.6922 4 13.0749C3.9993 11.6955 4.34019 10.3375 4.99222 9.12198C5.64426 7.90648 6.58715 6.87137 7.73671 6.10906C7.80702 6.06227 7.88587 6.02978 7.96874 6.01346C8.05161 5.99714 8.13689 5.99731 8.21969 6.01395C8.3025 6.03059 8.38122 6.06338 8.45135 6.11045C8.52149 6.15752 8.58166 6.21794 8.62844 6.28827Z"
                                        fill="#D21C1F"
                                      />
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M12.3601 3C12.4446 3 12.5282 3.01663 12.6062 3.04895C12.6842 3.08127 12.7551 3.12864 12.8148 3.18835C12.8746 3.24807 12.9219 3.31896 12.9542 3.39698C12.9866 3.475 13.0032 3.55863 13.0032 3.64308V10.5026C13.0032 10.6731 12.9354 10.8367 12.8148 10.9573C12.6942 11.0779 12.5307 11.1456 12.3601 11.1456C12.1896 11.1456 12.026 11.0779 11.9054 10.9573C11.7848 10.8367 11.717 10.6731 11.717 10.5026V3.64308C11.717 3.47252 11.7848 3.30895 11.9054 3.18835C12.026 3.06775 12.1896 3 12.3601 3Z"
                                        fill="#D21C1F"
                                      />
                                    </svg>
                                  </span>
                                  Logout
                                </button>
                              </li>
                            </>
                          ) : isSignUp ? (
                            // Signed up but not logged in
                            <>
                              <li
                                style={{ padding: "16px", textAlign: "left" }}
                              >
                                <p
                                  style={{
                                    margin: 0,
                                    color: "#112C3B",
                                    fontWeight: 700,
                                  }}
                                >
                                  Welcome Back!
                                </p>
                                <p
                                  style={{
                                    fontSize: "16px",
                                    margin: 0,
                                    color: "#112C3B",
                                  }}
                                >
                                  Welcome to DigiCartt - Your Smart Shopping
                                  Partner.
                                </p>
                              </li>
                              <li
                                style={{
                                  display: "flex",
                                  paddingLeft: "2px",
                                  paddingRight: "2px",
                                  gap: "8px",
                                  justifyContent: "center",
                                  paddingBottom: "5px",
                                  borderBottom:
                                    "1px solid rgba(17, 44, 59, 0.12)",
                                }}
                              >
                                <button
                                  type="submit"
                                  className="btn btn-outline-dark w-100 rounded-pill"
                                  onClick={() => {
                                    navigate("/login");
                                    window.scrollTo(0, 0);
                                  }}
                                >
                                  Login
                                </button>
                              </li>
                              <li>
                                <button
                                  type="button"
                                  className="dropdown-item"
                                  data-bs-toggle="offcanvas"
                                  data-bs-target="#wishlistDrawer"
                                  aria-controls="wishlistDrawer"
                                  style={{ color: "black", textDecoration: 'none', background: 'none', border: 'none', width: '100%', textAlign: 'left', padding: '0.5rem 1rem', display: 'flex', alignItems: 'center', gap: '8px' }}
                                >
                                  <span>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        d="M18.1721 4.67022C14.5795 2.74344 12 5.58373 12 5.58373C12 5.58373 9.42042 2.74344 5.8279 4.67021C1.47665 7.00391 1.1642 16.1428 12 20.2C22.8359 16.1428 22.5233 7.00392 18.1721 4.67022Z"
                                        stroke="#112C3B"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                      />
                                    </svg>
                                  </span>
                                  Favorite
                                </button>
                              </li>
                            </>
                          ) : (
                            // Not logged in or signed up
                            <>
                              <li
                                style={{ padding: "16px", textAlign: "left" }}
                              >
                                <p
                                  style={{
                                    margin: 0,
                                    color: "#112C3B",
                                    fontWeight: 700,
                                  }}
                                >
                                  Welcome!
                                </p>
                                <p
                                  style={{
                                    fontSize: "16px",
                                    margin: 0,
                                    color: "#112C3B",
                                  }}
                                >
                                  Welcome to DigiCartt - Your Smart Shopping
                                  Partner.
                                </p>
                              </li>
                              <li
                                style={{
                                  display: "flex",
                                  paddingLeft: "2px",
                                  paddingRight: "2px",
                                  gap: "8px",
                                  justifyContent: "center",
                                  paddingBottom: "5px",
                                  borderBottom:
                                    "1px solid rgba(17, 44, 59, 0.12)",
                                }}
                              >
                                <button
                                  type="button"
                                  className="btn btn-outline-dark w-50 rounded-pill"
                                  onClick={() => {
                                    navigate("/login");
                                    window.scrollTo(0, 0);
                                  }}
                                >
                                  Login
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-dark w-50 rounded-pill"
                                  onClick={() => {
                                    navigate("/signup");
                                    window.scrollTo(0, 0);
                                  }}
                                >
                                  Sign up{" "}
                                </button>
                              </li>
                              {isLoggedIn && (
                                <li>
                                  <button
                                    type="button"
                                    className="dropdown-item"
                                    data-bs-toggle="offcanvas"
                                    data-bs-target="#wishlistDrawer"
                                    aria-controls="wishlistDrawer"
                                    style={{ color: "black", textDecoration: 'none', background: 'none', border: 'none', width: '100%', textAlign: 'left', padding: '0.5rem 1rem', display: 'flex', alignItems: 'center', gap: '8px' }}
                                  >
                                    <span>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <path
                                          d="M18.1721 4.67022C14.5795 2.74344 12 5.58373 12 5.58373C12 5.58373 9.42042 2.74344 5.8279 4.67021C1.47665 7.00391 1.1642 16.1428 12 20.2C22.8359 16.1428 22.5233 7.00392 18.1721 4.67022Z"
                                          stroke="#112C3B"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                        />
                                      </svg>
                                    </span>
                                    Favorite
                                  </button>
                                </li>
                              )}
                            </>
                          )}
                        </ul>
                      </div>
                    </div>
                    <div
                      className="header_cart_box d-sm-inline-block d-none"
                      style={{ position: "relative", display: "inline-block",cursor:'pointer' }}
                      onClick={() => {
                        navigate(isLoggedIn ? '/cart' : '/login');
                        setTimeout(() => window.scrollTo(0, 0), 0);
                      }}

                    >
                      {cartCount > 0 && (
                        <span
                          style={{
                            position: "absolute",
                            top: "-8px",
                            right: "-8px",
                            background: "#dc3545",
                            color: "white",
                            borderRadius: "50%",
                            width: "20px",
                            height: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "11px",
                            fontWeight: "bold",
                            zIndex: 1,
                          }}
                        >
                          {cartCount > 99 ? "99+" : cartCount}
                        </span>
                      )}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_1026_4792)">
                          <path
                            d="M7.53613 15.0508C8.05985 15.0516 8.56238 15.2605 8.93262 15.6309C9.30279 16.0013 9.51121 16.5037 9.51172 17.0274C9.51169 17.4181 9.39574 17.8002 9.17871 18.125C8.96154 18.45 8.65214 18.703 8.29102 18.8526C7.92993 19.0021 7.53269 19.0412 7.14941 18.9649C6.76614 18.8885 6.41397 18.7003 6.1377 18.4239C5.8615 18.1475 5.67379 17.7954 5.59766 17.4121C5.52153 17.0288 5.56032 16.6316 5.70996 16.2705C5.85967 15.9095 6.11339 15.6008 6.43848 15.3838C6.76347 15.1669 7.14539 15.0507 7.53613 15.0508ZM15.084 15.0508C15.6076 15.0516 16.1093 15.2606 16.4795 15.6309C16.8497 16.0013 17.0581 16.5037 17.0586 17.0274C17.0586 17.4182 16.9427 17.8001 16.7256 18.125C16.5085 18.4499 16.1999 18.703 15.8389 18.8526C15.4778 19.0021 15.0805 19.0411 14.6973 18.9649C14.314 18.8886 13.9618 18.7003 13.6855 18.4239C13.4092 18.1474 13.2207 17.7955 13.1445 17.4121C13.0684 17.0288 13.1081 16.6316 13.2578 16.2705C13.4075 15.9096 13.6604 15.6008 13.9854 15.3838C14.3104 15.1668 14.6931 15.0506 15.084 15.0508ZM7.36914 16.1875C7.20326 16.2205 7.05031 16.3014 6.93066 16.4209C6.81102 16.5406 6.7293 16.6935 6.69629 16.8594C6.66331 17.0254 6.68026 17.1982 6.74512 17.3545C6.80999 17.5107 6.91985 17.6445 7.06055 17.7383C7.20131 17.8322 7.36693 17.882 7.53613 17.8819C7.76274 17.8817 7.98039 17.7911 8.14062 17.6309C8.3006 17.4708 8.39034 17.2537 8.39062 17.0274C8.39079 16.8582 8.34093 16.6926 8.24707 16.5518C8.15317 16.411 8.01955 16.3012 7.86328 16.2364C7.70704 16.1716 7.53505 16.1547 7.36914 16.1875ZM14.916 16.1875C14.7501 16.2205 14.5972 16.3013 14.4775 16.4209C14.3579 16.5406 14.2762 16.6934 14.2432 16.8594C14.2102 17.0254 14.2281 17.1982 14.293 17.3545C14.3579 17.5106 14.4678 17.6445 14.6084 17.7383C14.7491 17.8321 14.9149 17.882 15.084 17.8819C15.3103 17.8818 15.5274 17.7918 15.6875 17.6319C15.8477 17.4716 15.9384 17.254 15.9385 17.0274C15.9386 16.8581 15.8879 16.6926 15.7939 16.5518C15.7 16.411 15.5665 16.3012 15.4102 16.2364C15.2539 16.1716 15.082 16.1546 14.916 16.1875ZM3.29004 0.900431C3.41687 0.900306 3.54037 0.942591 3.63965 1.02152C3.73892 1.1005 3.8085 1.21136 3.83691 1.335L4.5957 4.62602L17.7539 4.67387H17.7529C18.022 4.67267 18.2879 4.73664 18.5273 4.85942C18.7662 4.98202 18.9721 5.16029 19.1279 5.37895C19.2862 5.59656 19.3901 5.84928 19.4307 6.11527C19.4712 6.38122 19.4476 6.65343 19.3613 6.90824L17.2881 13.125C17.1757 13.4629 16.9598 13.7567 16.6709 13.9649C16.382 14.1731 16.0348 14.2836 15.6787 14.2832V14.2842H7.02539C6.64125 14.2856 6.26843 14.1561 5.96777 13.917C5.70466 13.7078 5.51051 13.4258 5.40918 13.1075L5.37109 12.9688L2.84473 2.02055H0.459961C0.311568 2.02047 0.169434 1.96137 0.0644531 1.85649C-0.0406161 1.75142 -0.0996094 1.60859 -0.0996094 1.46C-0.09953 1.31152 -0.0405454 1.16949 0.0644531 1.06449C0.169452 0.959495 0.311479 0.90051 0.459961 0.900431H3.29004ZM6.46094 12.7159V12.7168C6.48957 12.8439 6.56113 12.9571 6.66309 13.0381C6.76511 13.1192 6.89215 13.163 7.02246 13.1621H15.6768C15.7978 13.1633 15.9161 13.1261 16.0146 13.0557C16.1131 12.9853 16.1864 12.8854 16.2246 12.7705L18.2979 6.55277L18.2988 6.5518C18.3287 6.46579 18.3368 6.37326 18.3232 6.28324C18.3096 6.19349 18.2744 6.10838 18.2207 6.0352L18.2197 6.03324C18.1666 5.95838 18.0955 5.89723 18.0137 5.85551C17.9321 5.81396 17.8416 5.79314 17.75 5.79399H17.748L4.85254 5.75004L6.46094 12.7159Z"
                            fill="#112C3B"
                            stroke="#112C3B"
                            strokeWidth="0.2"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1026_4792">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <button
                      type="button"
                      className="header_favourite_box d-sm-none d-inline-block"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#wishlistDrawer"
                      aria-controls="wishlistDrawer"
                      style={{ background: 'none', border: 'none' }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M15.1434 3.89185C12.1496 2.2862 10 4.65311 10 4.65311C10 4.65311 7.85035 2.2862 4.85658 3.89184C1.23055 5.83659 0.970167 13.4523 10 16.8333C19.0299 13.4523 18.7694 5.8366 15.1434 3.89185Z"
                          stroke="#141B34"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <WishlistDrawer />
    </header>
  );
};

export default Header;
